import { RefabricBlogURL } from "../index";
import { IBlogAuthor, IBlogListParams, IBlogPost, IBlogPostListResponse, IBlogResolveRedirect, IBlogSitemapEntry, IBlogTerm } from "./blog.type";

// The blog API returns a few different envelope shapes (see handover):
//  - /posts, /categories/{slug}, /tags/{slug}  -> { data, page }
//  - /posts/{slug}                             -> { responseData: post }
//  - /categories, /tags, /sitemap              -> bare array
//  - /authors/{slug}, /resolve-redirect        -> bare object
// HttpClient.get returns the raw HTTP body, so we cast per-endpoint.

function buildParams(params: IBlogListParams = {}) {
  const query: Record<string, string | number | boolean> = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") query[key] = value;
  });

  return { params: query };
}

export default {
  async listPosts(params?: IBlogListParams): Promise<IBlogPostListResponse> {
    const res = await RefabricBlogURL.get<any>("posts", buildParams(params));

    return res as unknown as IBlogPostListResponse;
  },

  async getPost(slug: string): Promise<IBlogPost> {
    // SuccessDefault envelope: full post is under responseData.
    const res = await RefabricBlogURL.get<IBlogPost>(`posts/${encodeURIComponent(slug)}`, {});

    return (res.responseData ?? (res as unknown as IBlogPost)) as IBlogPost;
  },

  async getCategories(): Promise<IBlogTerm[]> {
    const res = await RefabricBlogURL.get<any>("categories", {});

    return res as unknown as IBlogTerm[];
  },

  async getPostsByCategory(slug: string, params?: IBlogListParams): Promise<IBlogPostListResponse> {
    const res = await RefabricBlogURL.get<any>(`categories/${encodeURIComponent(slug)}`, buildParams(params));

    return res as unknown as IBlogPostListResponse;
  },

  async getTags(): Promise<IBlogTerm[]> {
    const res = await RefabricBlogURL.get<any>("tags", {});

    return res as unknown as IBlogTerm[];
  },

  async getPostsByTag(slug: string, params?: IBlogListParams): Promise<IBlogPostListResponse> {
    const res = await RefabricBlogURL.get<any>(`tags/${encodeURIComponent(slug)}`, buildParams(params));

    return res as unknown as IBlogPostListResponse;
  },

  async getAuthor(slug: string): Promise<IBlogAuthor> {
    const res = await RefabricBlogURL.get<any>(`authors/${encodeURIComponent(slug)}`, {});

    return (res?.responseData ?? res) as unknown as IBlogAuthor;
  },

  async getSitemap(): Promise<IBlogSitemapEntry[]> {
    const res = await RefabricBlogURL.get<any>("sitemap", {});

    return res as unknown as IBlogSitemapEntry[];
  },

  async resolveRedirect(path: string): Promise<IBlogResolveRedirect | null> {
    try {
      const res = await RefabricBlogURL.get<any>("resolve-redirect", { params: { path } });
      const data = (res?.responseData ?? res) as IBlogResolveRedirect;

      return data?.to_path ? data : null;
    } catch {
      return null;
    }
  },
};
